import axios from 'axios';
import { omit } from 'lodash';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';

const useCreateProjectModule = () => {
  const { mutateAsync, isLoading } = useMutation(async ({ module, projectId }) => {
    return await axios.post(`/standardization/${projectId}/modules`, module);
  });

  const createModule = async (module, projectId, options) => {
    mutateAsync(
      { module: module, projectId },
      {
        onSuccess: (res) => {
          toast.success(`Successfully saved the module with tag: ${res.data.tsCode}!`);
          options?.onSuccess && options.onSuccess(res.data);
        },
      }
    );
  };

  return {
    createModule,
    isLoading,
  };
};

export default useCreateProjectModule;
